import React from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import './chat.styles.scss'

import { ACTION, CATEGORY, DataLayer, EVENT, GoogleAnalyticsDataLayer } from 'src/utils/google-analytics'
import { useChatNotification } from 'src/hooks/use-chat-notification'
import { useSelector } from 'src/store/redux.store'
import { ReactComponent as ChatSVG } from '../../assets/menu-chat.svg'

const Chat = ({ tabIndex }) => {
  const user = useSelector(state => state.user)
  const { t } = useTranslation()
  const history = useHistory()
  const { unreadMessagesCounter } = useChatNotification()

  const chatMenuClickHandler = () => {
    const dataLayer = new DataLayer(
      EVENT.INTERACTION,
      CATEGORY.UNIVERSAL_BAR,
      ACTION.CLICK_MENU_COMMUNICATION,
      'communication'
    )

    GoogleAnalyticsDataLayer.sendPageInteraction(dataLayer)
    history.push('/communication')
  }

  function handleChatKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      chatMenuClickHandler()
    }
  }

  return (
    user && (
      <div slot="header-actions">
        <hot-menu-item
          slot="button"
          class="_cursor-pointer"
          onKeyDown={handleChatKeydown}
          onClick={chatMenuClickHandler}
          tabIndex={tabIndex}
          role="link"
        >
          <div className="hot-application-menu__icon">
            <hot-tooltip content={t('header.menu.general.messages')} position="bottom" class="_d-flex">
              <ChatSVG />
              {unreadMessagesCounter ? (
                <span className="header-chat__notification">
                  {unreadMessagesCounter < 100 ? unreadMessagesCounter : '99+'}
                </span>
              ) : (
                ''
              )}
            </hot-tooltip>
          </div>
        </hot-menu-item>
      </div>
    )
  )
}

export default React.memo(Chat)
